import { createRecommendedAccosAPIClient } from './recommendedAccosAPIClient';

export const recommendedAccosAPIClient = createRecommendedAccosAPIClient();
